import { KeyNames } from "../../constants/keyNames";

export function isKeyboardClick(event: React.KeyboardEvent<HTMLElement>) {
  return event.key === KeyNames.SPACE || event.key === KeyNames.ENTER;
}
